import axiosInstance from "@/api/axios-instance";
import { PaymentPageFormData } from "@/pages/payment-pages/types/payment-page";

function parseJsonField(value?: string) {
  if (!value) return undefined;
  try {
    return JSON.parse(value);
  } catch {
    return undefined;
  }
}

export async function updatePaymentPage(
  id: string,
  data: Partial<PaymentPageFormData>,
) {
  const payload = {
    ...data,
    description: parseJsonField(data.description),
    plan_details: parseJsonField(data.plan_details),
    tnc: parseJsonField(data.tnc),
    how_it_works: parseJsonField(data.how_it_works),
    // null clears the add-on on the page; undefined leaves it untouched.
    add_on:
      data.add_on === undefined
        ? undefined
        : data.add_on?.target_standard_id
          ? data.add_on
          : null,
  };

  const response = await axiosInstance.patch(`/payment-pages/${id}`, payload);
  return response.data;
}
